/* eslint-disable */
/* eslint-disable no-lonely-if */
// eslint-disable-next-line no-unused-vars
import {
  get,
  head,
  filter,
  map,
  pick,
  nth,
  fill,
  extend,
  isNil,
  isArray,
  indexOf,
  findIndex,
  defaultTo
} from 'lodash-es';

const emit = (vnode, name, data) => {
  const handlers = vnode.data.on;

  // eslint-disable-next-line no-prototype-builtins
  if (handlers && handlers.hasOwnProperty(name)) {
    const handler = handlers[name];
    const fn = handler.fns || handler.fn;

    if (typeof fn === 'function') {
      fn(data);
    }
  }
};

const getDef = vnode => {
  return get(
    head(
      filter(
        get(vnode, 'data.directives'),
        item => get(pick(item, ['rawName']), 'rawName') === 'v-toggle'
      )
    ),
    'def'
  );
};

export default {
  getOptions(bind) {
    const defaults = {
      target: null,
      selector: null,
      onTag: 'li', // onInit()를 위함
      onClass: 'on', // onInit()를 위함
      onlyOpen: true, // false 시 다중 활성화 가능
      mustClose: false, // 열려있는 것 클릭 시 닫을 지 유무
      dataType: Number()
    };

    return extend({}, defaults, bind.value);
  },

  getTarget(target, { selector }) {
    return isNil(selector) ? [target] : target.querySelectorAll(selector);
  },

  getClassTarget(target, { onTag }) {
    return onTag === 'a' || onTag === 'button' ? target : target.closest(onTag);
  },

  bind(el, bind, vnode, oldVNode) {
    // console.log('@@@@@ bind', el)
  },

  inserted(el, bind, vnode) {
    // console.log('@@@@@ inserted', el)
    const scope = getDef(vnode);
    const opts = scope.getOptions(bind);

    const targetRef = get(vnode.context.$refs, opts.target);

    if (isNil(targetRef)) return;

    const btns = scope.getTarget(targetRef, opts);
    const isNumber = typeof opts.dataType === 'number';

    // act 초기 설정
    let acts = map(btns, (item, idx) => {
      if (
        indexOf(scope.getClassTarget(item, opts).classList, opts.onClass) >= 0
      ) {
        return isNumber ? idx : true;
      } else {
        return isNumber ? null : false;
      }
    });
    if (isNumber && opts.onlyOpen) acts = defaultTo(head(acts), 0); // idx 용

    map(btns, (btn, act) => {
      btn.addEventListener('click', e => {
        if (!isNumber && !isArray(acts)) acts = [acts]; // toggle 용

        if (e.currentTarget.tagName.toLowerCase() === 'a') {
          e.preventDefault();
        }

        if (opts.onlyOpen) {
          if (isNumber) {
            if (!opts.mustClose) {
              acts = act;
            } else {
              // 열린 마지막 닫기
              acts = act !== acts ? act : null;
            }
          } else {
            if (!opts.mustClose) {
              acts = map(acts, (item, idx) => idx === act);
            } else {
              // 열린 마지막 닫기
              acts = !nth(acts, act)
                ? map(acts, (item, idx) => idx === act)
                : fill([...acts], false);

              if (acts.length <= 1) acts = head(acts); // toggle 용
            }
          }
        } else {
          let add;

          if (isNumber) {
            add = findIndex(acts, val => val === act) !== -1 ? null : act;
          } else {
            add = !nth(acts, act);
          }

          acts = fill([...acts], add, act, act + 1);
        }

        emit(vnode, 'onChange', { acts });
      });
    });

    emit(vnode, 'onInit', { acts });
  },

  componentUpdated(el) {
    // console.log('@@@@@ componentUpdated', el)
  },

  unbind(el) {
    // console.log('@@@@@ unbind', el)
  }
};

if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i,
      el = this;
    do {
      i = matches.length;
      while (--i >= 0 && matches.item(i) !== el) {}
    } while (i < 0 && (el = el.parentElement));
    return el;
  };
}
